'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.ActionTypes = void 0;
(function (ActionTypes) {
    ActionTypes["SORT_LIST"] = "SORT_LIST";
    ActionTypes["FILTER_LIST"] = "FILTER_LIST";
    ActionTypes["SET_ITEMS_PER_PAGE"] = "SET_ITEMS_PER_PAGE";
    ActionTypes["SET_CURRENT_PAGE"] = "SET_CURRENT_PAGE";
})(exports.ActionTypes || (exports.ActionTypes = {}));
//# sourceMappingURL=actionTypes.js.map
